import { Link } from 'react-router-dom'
import type { RosProjectRow } from './types'

// Проекты: список с ответственным закупщиком и прогрессом квотирования.
// Внутренний скролл (max-height) — на сотнях проектов блок не растягивается.

export function RosProjectsCard({ items, total }: { items: RosProjectRow[]; total: number }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm text-gray-500">Проекты</div>
        <span className="text-xs text-gray-400">
          {total > items.length ? `показано ${items.length} из ${total}` : `всего: ${total}`}
        </span>
      </div>
      {items.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400 py-6">
          Проектов в очереди нет
        </div>
      ) : (
        <div className="flex-1 max-h-[320px] overflow-y-auto pr-1 space-y-1.5">
          {items.map((p) => (
            <Link
              key={p.requestId}
              to={`/requests/${p.requestId}`}
              className="block rounded-xl border border-gray-100 bg-gray-50 px-3 py-2 hover:border-brand-200 hover:bg-brand-50/40 transition-colors"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-gray-900 truncate">{p.title}</span>
                <span className="text-xs text-gray-500 shrink-0 tabular-nums">
                  {p.itemsQuoted}/{p.itemsTotal}
                </span>
              </div>
              <div className="mt-1 flex items-center gap-2">
                <div className="flex-1 h-1.5 bg-gray-200 rounded overflow-hidden">
                  <div
                    className="h-full rounded bg-violet-500 transition-all"
                    style={{ width: `${Math.max(2, p.progressPct)}%` }}
                  />
                </div>
                <span className="text-xs font-semibold text-gray-700 tabular-nums w-9 text-right">
                  {p.progressPct}%
                </span>
              </div>
              <div className="mt-0.5 text-xs text-gray-500 truncate">
                {p.responsibleBuyerName
                  ? `закупщик: ${p.responsibleBuyerName}`
                  : 'закупщик не закреплён'}
                {p.brands.length > 0 && ` · ${p.brands.join(', ')}`}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
